import React, { Component } from "react";
import { Link } from "react-router-dom";
import { loading } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import {
  SectionHead, Btn, FeatureCard, SolutionCard, TeamChip,
  StepCard, PortfolioCard, FaqItem, CtaBand, Reveal, Quote, CountUp,
} from "../components/ui.js";
import { Blob, DottedGrid, DashboardArt, MascotBot } from "../components/illustrations.js";

/* ============================================================
   LEVELUP ONE — Home
   ============================================================ */

export default class Index extends Component {
  componentDidMount() {
    loading(false);
    window.scrollTo(0, 0);
  }

  render() {
    const products = [
      { icon: "🧾", name: "Samai POS", desc: "ระบบขายหน้าร้านบนคลาวด์ ทำงานต่อได้แม้ออฟไลน์" },
      { icon: "📦", name: "Meedee ERP", desc: "บริหารคลัง บัญชี และคำสั่งซื้อในที่เดียว" },
      { icon: "🤖", name: "Manager AI", desc: "สั่งงาน AI ผ่านแชตเหมือนคุยกับผู้จัดการ" },
      { icon: "🧺", name: "Wash Cloud", desc: "ระบบจัดการร้านซักรีดครบวงจร" },
      { icon: "💪", name: "Fit System", desc: "ระบบสมาชิกและตารางคลาสฟิตเนส" },
      { icon: "🚚", name: "Track Go", desc: "ติดตามการจัดส่งและยานพาหนะแบบเรียลไทม์" },
    ];

    const team = [
      { face: "🧮", name: "น้องบัญชี", role: "ออกใบกำกับ/ปิดงบ", bg: "#eef2ff" },
      { face: "📦", name: "น้องสต็อก", role: "เช็กคลังอัตโนมัติ", bg: "#f0fdf4" },
      { face: "📈", name: "น้องขาย", role: "สรุปยอดรายวัน", bg: "#fef3c7" },
      { face: "🧑‍💼", name: "น้อง HR", role: "จัดกะ/คิดเงินเดือน", bg: "#fae8ff" },
      { face: "📊", name: "น้องรายงาน", role: "ทำแดชบอร์ด", bg: "#ecfeff" },
      { face: "💬", name: "น้องบริการ", role: "ตอบลูกค้าบน LINE", bg: "#ffe4e6" },
    ];

    const solutions = [
      { icon: "🛒", title: "Cloud POS ร้านค้าปลีก", desc: "ขายหน้าร้าน/ออนไลน์ ซิงก์สต็อกอัตโนมัติ" },
      { icon: "🧺", title: "ระบบจัดการร้านซักรีด", desc: "รับงาน คิดเงิน แจ้งเตือนลูกค้าครบวงจร" },
      { icon: "🏋️", title: "ระบบฟิตเนส", desc: "สมาชิก แพ็กเกจ และตารางคลาส" },
      { icon: "🏬", title: "ระบบจัดการคลังสินค้า", desc: "รับเข้า-เบิกออก ตรวจนับ และรายงาน" },
      { icon: "🍽️", title: "POS ร้านอาหาร + AI", desc: "สั่งอาหาร ครัว และวิเคราะห์เมนูขายดี" },
      { icon: "🏢", title: "Enterprise ERP", desc: "เชื่อมทุกแผนกในระบบเดียว ติดตั้งใน 1 สัปดาห์" },
    ];

    const portfolio = [
      { icon: "🧼", photo: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=800&q=80", tag: "Mobile App", title: "D-Clean แอประบบทำความสะอาด", problem: "จองคิวซ้ำซ้อน จัดทีมยาก", result: "ลดเวลาจัดคิว 60% รับงานเพิ่ม 2 เท่า" },
      { icon: "🍜", photo: "https://images.unsplash.com/photo-1552566626-52f8b828add9?auto=format&fit=crop&w=800&q=80", tag: "AI POS", title: "ร้านอาหาร AI POS", problem: "สต็อกวัตถุดิบคลาดเคลื่อน", result: "ลดของเสีย 35% รู้เมนูทำกำไรทันที" },
      { icon: "🛍️", photo: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=800&q=80", tag: "E-commerce", title: "แพลตฟอร์มขายออนไลน์", problem: "หลายช่องทาง สต็อกไม่ตรง", result: "รวมออเดอร์ทุกช่องทางใน 1 จอ" },
      { icon: "🧺", photo: "https://images.unsplash.com/photo-1545173168-9f1947eebb7f?auto=format&fit=crop&w=800&q=80", tag: "Booking AI", title: "ระบบจองร้านซักรีด AI", problem: "ตอบแชตจองคิวช้า", result: "ตอบลูกค้าเร็วขึ้น 12 เท่า ปิดการขายมากขึ้น" },
    ];

    const reviews = [
      { text: "ทีม AI ช่วยสรุปยอดและตอบลูกค้าบน LINE ได้เองทุกวัน เรามีเวลาไปดูแลร้านมากขึ้นจริง ๆ", name: "คุณแนน", role: "เจ้าของคาเฟ่ 2 สาขา", avatar: "☕" },
      { text: "ติดตั้งบนระบบ POS เดิมได้เลย ไม่ต้องเปลี่ยนของที่ใช้อยู่ พนักงานปรับตัวง่ายมาก", name: "คุณเอก", role: "ผู้จัดการร้านอาหาร", avatar: "🍜" },
      { text: "รายงานสต็อกที่เคยทำเป็นชั่วโมง ตอนนี้ AI ทำให้เสร็จในไม่กี่นาที คุ้มเกินราคา", name: "คุณฟ้า", role: "เจ้าของร้านค้าปลีก", avatar: "🛍️" },
    ];

    const journey = [
      { num: "1", time: "ฟรี 30 นาที", title: "ปรึกษา", desc: "คุยปัญหาธุรกิจและเป้าหมาย ประเมินความเป็นไปได้" },
      { num: "2", time: "ภายใน 1 สัปดาห์", title: "เสนอแนวทาง", desc: "ออกแบบโซลูชันและขอบเขตงานพร้อมราคาชัดเจน" },
      { num: "3", time: "2–4 สัปดาห์", title: "พัฒนา", desc: "ลงมือสร้างและทดสอบบนระบบเดิมของคุณ" },
      { num: "4", time: "ดูแลต่อเนื่อง", title: "ส่งมอบ & ซัพพอร์ต", desc: "อบรมการใช้งานและดูแลหลังส่งมอบ" },
    ];

    const features = [
      { icon: "🔌", title: "ทำงานบนระบบเดิม", desc: "เชื่อมต่อ LINE, POS, Excel โดยไม่ต้องรื้อของเดิม" },
      { icon: "⚡", title: "เริ่มใช้ได้ไว", desc: "ติดตั้งและเห็นผลได้ภายในไม่กี่สัปดาห์" },
      { icon: "🧠", title: "AI เฉพาะทางธุรกิจ", desc: "ปรับแต่งให้เข้าใจบริบทและข้อมูลของคุณ" },
      { icon: "🛡️", title: "ปลอดภัยมั่นใจ", desc: "มาตรฐานความปลอดภัยข้อมูลระดับองค์กร" },
    ];

    const faqs = [
      { q: "LevelUp One คือใคร?", a: "บริษัทพัฒนาซอฟต์แวร์ที่สร้าง “พนักงาน AI” ช่วยให้ธุรกิจ SME ทำงานอัตโนมัติบนระบบที่ใช้อยู่เดิม" },
      { q: "ต้องเปลี่ยนระบบเดิมทั้งหมดไหม?", a: "ไม่ต้อง เราออกแบบให้ AI ทำงานเชื่อมกับ LINE, POS หรือ Excel ที่คุณใช้อยู่แล้ว" },
      { q: "ใช้เวลาพัฒนานานแค่ไหน?", a: "โดยทั่วไป 2–4 สัปดาห์ ขึ้นกับขอบเขตงาน ระบบสำเร็จรูปบางตัวติดตั้งได้ใน 1 สัปดาห์" },
      { q: "มีบริการดูแลหลังส่งมอบไหม?", a: "มีครับ เราอบรมการใช้งานและดูแลต่อเนื่องหลังส่งมอบทุกโปรเจกต์" },
      { q: "คิดราคาอย่างไร?", a: "เราประเมินตามขอบเขตงานจริงและแจ้งราคาชัดเจนก่อนเริ่ม ไม่มีค่าใช้จ่ายแอบแฝง" },
    ];

    return (
      <div className="nx">
        <Navbar />

        {/* ===== HERO ===== */}
        <section className="nx-hero">
          <span className="nx-orb nx-orb--a" aria-hidden="true" />
          <span className="nx-orb nx-orb--b" aria-hidden="true" />
          <div className="container" style={{ position: "relative", zIndex: 1 }}>
            <div className="row align-items-center g-5">
              <div className="col-12 col-lg-6">
                <span className="nx-eyebrow">AI สำหรับธุรกิจ SME</span>
                <h1 className="nx-hero__title mt-3">
                  AI ที่ทำงานจริง<br />
                  <span className="nx-gradient-text">บนระบบเดิมของคุณ</span>
                </h1>
                <p className="nx-hero__lead">
                  เชื่อมต่อระบบที่คุณใช้อยู่ ตอบลูกค้าผ่าน LINE และทำรายงานอัตโนมัติ
                  โดยไม่ต้องทิ้งเครื่องมือเดิม ให้ AI เป็นทีมงานที่ไม่เคยหยุดพัก
                </p>
                <div className="nx-hero__actions">
                  <Btn to="/booking">ทดลองใช้ฟรี 30 วัน</Btn>
                  <Btn href="https://line.me" variant="ghost">คุย LINE ก่อน</Btn>
                </div>
                <div className="nx-hero__stats">
                  <div><div className="nx-stat__num"><CountUp end={8} suffix=" ชม." /></div><div className="nx-stat__label">ประหยัดต่อสัปดาห์</div></div>
                  <div><div className="nx-stat__num"><CountUp end={12} suffix="×" /></div><div className="nx-stat__label">ตอบลูกค้าเร็วขึ้น</div></div>
                  <div><div className="nx-stat__num"><CountUp end={30} suffix="+" /></div><div className="nx-stat__label">ชั่วโมงที่ได้คืน</div></div>
                </div>
              </div>

              <div className="col-12 col-lg-6">
                <div className="nx-hero__visual">
                  <Blob className="nx-blob nx-blob--hero" />
                  <DottedGrid className="nx-dots" style={{ bottom: -24, left: -24 }} />
                  <div className="nx-float nx-float--tl">
                    <span className="nx-float__icon">📦</span> สต็อกอัปเดตแล้ว
                  </div>
                  <div className="nx-float nx-float--br">
                    <span className="nx-float__icon">✅</span> ออกใบกำกับสำเร็จ
                  </div>
                  <div className="nx-chat">
                    <div className="nx-chat__head">
                      <div className="nx-chat__avatar">AI</div>
                      <div>
                        <div className="nx-chat__name">น้องเลเวล · ผู้ช่วย AI</div>
                        <div className="nx-chat__status">กำลังออนไลน์</div>
                      </div>
                    </div>
                    <div className="nx-chat__body">
                      <div className="nx-bubble nx-bubble--in">สรุปยอดขายสาขาทองหล่อวันนี้ให้หน่อย</div>
                      <div className="nx-bubble nx-bubble--out">ยอดขายวันนี้ 42,800 บาท เพิ่มขึ้น 18% เมนูขายดีคือลาเต้เย็น ☕</div>
                      <div className="nx-bubble nx-bubble--in">สั่งวัตถุดิบที่ใกล้หมดด้วย</div>
                      <div className="nx-bubble nx-bubble--out">สร้างใบสั่งซื้อนม 24 ลัง และเมล็ดกาแฟ 5 กก. แล้ว ✅</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ===== TRUSTED LOGOS ===== */}
        <section className="nx-section--tight">
          <div className="container">
            <p className="text-center nx-muted mb-4" style={{ fontSize: "0.9rem" }}>เทคโนโลยีและพันธมิตรที่เราใช้</p>
            <div className="nx-marquee">
              <div className="nx-marquee__track">
                {["AWS", "OpenAI", "LINE", "Cloudflare", "Figma", "Omise", "ClickUp", "AWS", "OpenAI", "LINE", "Cloudflare", "Figma", "Omise", "ClickUp"].map((l, i) => (
                  <span className="nx-logos__item" key={`${l}-${i}`}>{l}</span>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ===== FLAGSHIP SPOTLIGHT ===== */}
        <section className="nx-section">
          <div className="container">
            <Reveal>
              <div className="nx-spotlight">
                <Blob className="nx-spotlight__blob" />
                <div className="row align-items-center g-5 position-relative">
                  <div className="col-12 col-lg-5">
                    <span className="nx-eyebrow">ผลิตภัณฑ์เรือธง</span>
                    <div className="nx-spotlight__word nx-gradient-text">LevelUp Suite</div>
                    <p className="nx-spotlight__lead">
                      ชุดเครื่องมือ AI ครบวงจรสำหรับธุรกิจ — POS, ERP, HRM และผู้ช่วย AI
                      ที่ทำงานร่วมกันบนระบบเดิมของคุณ คุมทุกอย่างได้จากที่เดียว
                    </p>
                    <div className="nx-spotlight__tags">
                      <span className="nx-spotlight__tag">ERP</span>
                      <span className="nx-spotlight__tag">POS</span>
                      <span className="nx-spotlight__tag">HRM</span>
                      <span className="nx-spotlight__tag">AI Manager</span>
                    </div>
                    <div className="d-flex flex-wrap gap-3">
                      <Btn to="/services">ดูบริการทั้งหมด</Btn>
                      <Btn to="/register" variant="ghost">ทดลองใช้ฟรี</Btn>
                    </div>
                  </div>
                  <div className="col-12 col-lg-7">
                    <div className="nx-browser">
                      <div className="nx-browser__bar">
                        <i style={{ background: "#f87171" }} /><i style={{ background: "#fbbf24" }} /><i style={{ background: "#34d399" }} />
                        <span className="nx-browser__url" />
                      </div>
                      <div className="nx-browser__body" style={{ padding: 18 }}><DashboardArt /></div>
                    </div>
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
        </section>

        {/* ===== PRODUCTS ===== */}
        <section className="nx-section nx-bg-surface">
          <div className="container">
            <Reveal>
              <SectionHead
                center
                eyebrow="ผลิตภัณฑ์ของเรา"
                title="ชุดเครื่องมือ AI ครบทุกงานธุรกิจ"
                subtitle="เลือกใช้ตามความต้องการ หรือผสมผสานให้เป็นทีม AI ที่ทำงานร่วมกัน"
              />
            </Reveal>
            <div className="row g-4 mt-2">
              {products.map((p, i) => (
                <div className="col-12 col-sm-6 col-lg-4" key={p.name}>
                  <Reveal delay={i * 60}>
                    <FeatureCard icon={p.icon} title={p.name} desc={p.desc} />
                  </Reveal>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== AI TEAM DEEP-DIVE ===== */}
        <section className="nx-section">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-12 col-lg-5">
                <Reveal>
                  <SectionHead
                    eyebrow="ทีม AI ทำงานพร้อมกัน"
                    title="เหมือนมีพนักงาน 10 คน ทำงานพร้อมกันใน 30 นาที"
                    subtitle="สั่งงานทีม AI ผ่านแชตเดียว ตั้งแต่บัญชี คลังสินค้า งานขาย ไปจนถึงบริการลูกค้า ทุกคนทำงานพร้อมกันแบบเรียลไทม์"
                  />
                  <div className="mt-4">
                    <Btn to="/services">ดูบริการทั้งหมด</Btn>
                  </div>
                </Reveal>
              </div>
              <div className="col-12 col-lg-7">
                <Reveal delay={120}>
                  <div className="nx-dashcard mb-4">
                    <DashboardArt />
                  </div>
                  <div className="nx-team-grid">
                    {team.map((t) => <TeamChip key={t.name} {...t} />)}
                  </div>
                </Reveal>
              </div>
            </div>
          </div>
        </section>

        {/* ===== RESULTS BAND ===== */}
        <section className="nx-section--tight">
          <div className="container">
            <Reveal>
              <div className="nx-band">
                <div className="row g-4 text-center text-lg-start position-relative">
                  <div className="col-6 col-lg-3"><div className="nx-band__num"><CountUp end={8} suffix=" ชม." /></div><div className="nx-band__label">ลดงานซ้ำซ้อนต่อสัปดาห์</div></div>
                  <div className="col-6 col-lg-3"><div className="nx-band__num"><CountUp end={12} suffix="×" /></div><div className="nx-band__label">ตอบลูกค้าเร็วขึ้น</div></div>
                  <div className="col-6 col-lg-3"><div className="nx-band__num"><CountUp end={30} suffix="+" /></div><div className="nx-band__label">ชั่วโมงที่ได้คืนต่อสัปดาห์</div></div>
                  <div className="col-6 col-lg-3"><div className="nx-band__num"><CountUp end={99.9} decimals={1} suffix="%" /></div><div className="nx-band__label">ความเสถียรของระบบ</div></div>
                </div>
              </div>
            </Reveal>
          </div>
        </section>

        {/* ===== SOLUTIONS ===== */}
        <section className="nx-section nx-bg-surface">
          <div className="container">
            <Reveal>
              <SectionHead
                center
                eyebrow="โซลูชันสำเร็จรูป"
                title="ระบบพร้อมใช้สำหรับแต่ละอุตสาหกรรม"
                subtitle="ปรับแต่งต่อยอดได้ตามธุรกิจของคุณ เริ่มใช้งานได้รวดเร็ว"
              />
            </Reveal>
            <div className="row g-4 mt-2">
              {solutions.map((s, i) => (
                <div className="col-12 col-md-6 col-lg-4" key={s.title}>
                  <Reveal delay={i * 50}><SolutionCard {...s} /></Reveal>
                </div>
              ))}
            </div>
            <div className="text-center mt-5">
              <Btn to="/innovation" variant="ghost">ดูนวัตกรรมทั้งหมด</Btn>
            </div>
          </div>
        </section>

        {/* ===== SERVICE CATEGORIES (dark big list) ===== */}
        <section className="nx-section nx-catlist-band">
          <div className="container">
            <Reveal>
              <SectionHead
                eyebrow="สิ่งที่เราทำ"
                title={<span style={{ color: "#fff" }}>บริการครบทุกด้านของซอฟต์แวร์</span>}
              />
            </Reveal>
            <div className="nx-catlist">
              {[
                { no: "01", name: "WEBSITE LANDING", to: "/services#brand-stage" },
                { no: "02", name: "NATIVE APPLICATION", to: "/services#custom-development" },
                { no: "03", name: "AI SOLUTION", to: "/services#ai-solutions" },
                { no: "04", name: "SAAS", to: "/services#saas-products" },
                { no: "05", name: "IT RESOURCES", to: "/services#it-talent" },
                { no: "06", name: "ARCHITECTURE", to: "/services#consulting" },
              ].map((c) => (
                <Link to={c.to} className="nx-catrow" key={c.no}>
                  <span className="nx-catrow__no">{c.no}</span>
                  <span className="nx-catrow__name">{c.name}</span>
                  <span className="nx-catrow__arrow" aria-hidden="true">→</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* ===== PORTFOLIO ===== */}
        <section className="nx-section">
          <div className="container">
            <Reveal>
              <SectionHead
                eyebrow="ผลงานของเรา"
                title="ผลลัพธ์จริงจากธุรกิจจริง"
                subtitle="ทุกโปรเจกต์เริ่มจากปัญหา แล้วจบที่ผลลัพธ์ที่วัดได้"
              />
            </Reveal>
            <div className="row g-4 mt-2">
              {portfolio.map((p, i) => (
                <div className="col-12 col-sm-6 col-lg-3" key={p.title}>
                  <Reveal delay={i * 60}><PortfolioCard {...p} /></Reveal>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== MOBILE APP ===== */}
        <section className="nx-section">
          <div className="container">
            <Reveal>
              <div className="nx-app">
                <div className="nx-app__inner">
                  <div className="nx-app__art"><MascotBot /></div>
                  <div className="nx-app__body">
                    <span className="nx-eyebrow" style={{ background: "rgba(255,255,255,0.15)", color: "#fff", border: "none" }}>แอปบนมือถือ</span>
                    <h2 className="mt-3">พกผู้ช่วย AI ไว้ในกระเป๋า</h2>
                    <p>รับการแจ้งเตือนทุกออเดอร์ใหม่แบบเรียลไทม์ สั่งงานทีม AI และดูยอดขายได้จากทุกที่</p>
                    <ul className="nx-app__list">
                      <li>แจ้งเตือนออเดอร์และสต็อกทันที</li>
                      <li>คุยกับผู้ช่วย AI ได้เหมือนแชต</li>
                      <li>ปลอดภัยด้วย Face ID / Touch ID</li>
                    </ul>
                    <div className="d-flex gap-3 flex-wrap">
                      <a href="https://line.me" className="nx-btn nx-btn--accent">ดาวน์โหลดแอป</a>
                      <Link to="/services" className="nx-btn nx-btn--light">ดูฟีเจอร์ทั้งหมด</Link>
                    </div>
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
        </section>

        {/* ===== TESTIMONIALS ===== */}
        <section className="nx-section nx-bg-surface">
          <div className="container">
            <Reveal>
              <SectionHead
                center
                eyebrow="เสียงจากลูกค้า"
                title="10+ องค์กรไทยไว้วางใจ ใช้งานต่อเนื่อง 12+ เดือน"
                subtitle="ผลลัพธ์จริงจากธุรกิจที่ให้ AI เข้ามาเป็นทีมงาน"
              />
            </Reveal>
            <div className="row g-4 mt-2">
              {reviews.map((r, i) => (
                <div className="col-12 col-md-4" key={r.name}>
                  <Reveal delay={i * 70}><Quote {...r} /></Reveal>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== JOURNEY ===== */}
        <section className="nx-section nx-bg-soft">
          <div className="container">
            <Reveal>
              <SectionHead
                center
                eyebrow="ขั้นตอนการทำงาน"
                title="จากปรึกษาถึงส่งมอบ ภายใน ~5 สัปดาห์"
                subtitle="กระบวนการชัดเจน โปร่งใส ทุกขั้นตอน"
              />
            </Reveal>
            <div className="row g-4 mt-2">
              {journey.map((s, i) => (
                <div className="col-12 col-sm-6 col-lg-3" key={s.num}>
                  <Reveal delay={i * 70}><StepCard {...s} /></Reveal>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== WHY US ===== */}
        <section className="nx-section">
          <div className="container">
            <Reveal>
              <SectionHead center eyebrow="ทำไมต้อง LevelUp One" title="ออกแบบมาเพื่อธุรกิจที่อยากโตเร็ว" />
            </Reveal>
            <div className="row g-4 mt-2">
              {features.map((f, i) => (
                <div className="col-12 col-sm-6 col-lg-3" key={f.title}>
                  <Reveal delay={i * 60}><FeatureCard {...f} /></Reveal>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== FAQ ===== */}
        <section className="nx-section nx-bg-surface">
          <div className="container">
            <div className="row g-5">
              <div className="col-12 col-lg-4">
                <Reveal>
                  <SectionHead eyebrow="คำถามที่พบบ่อย" title="มีคำถาม? เรามีคำตอบ" subtitle="หากยังสงสัย ทักหาเราได้ตลอดเวลา" />
                </Reveal>
              </div>
              <div className="col-12 col-lg-8">
                <Reveal delay={100}>
                  {faqs.map((f, i) => <FaqItem key={i} q={f.q} a={f.a} defaultOpen={i === 0} />)}
                </Reveal>
              </div>
            </div>
          </div>
        </section>

        <CtaBand />

        {/* ===== TAGLINE ===== */}
        <section className="nx-section--tight nx-bg-soft">
          <div className="container">
            <Reveal>
              <div className="nx-tagline">
                <h2 className="nx-tagline__title">สร้างจากไทย — <span className="nx-gradient-text">ส่งมอบทั่วโลก</span></h2>
                <div className="nx-tagline__card">
                  <span className="nx-eyebrow">เริ่มต้นง่าย ๆ</span>
                  <p className="nx-card__desc my-3">สมัครเป็น Early Adopter วันนี้ รับสิทธิ์ทดลองใช้ฟรี 30 วัน ไม่มีข้อผูกมัด</p>
                  <Btn to="/register" block>สมัครสมาชิก</Btn>
                </div>
              </div>
            </Reveal>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}
